import Grid from '@mui/material/Grid2';
import AnalysisFilterViewModel from "./ViewModels/AnalysisFilterViewModel";
import LandUseSelection from "./Filters/LandUseSelection";
import TripRateParameters from "./Filters/TripRateParameters";
import LocationType from './Filters/LocationType';
import FlowDirection from './Filters/FlowDirection';
import SurveyYears from './Filters/SurveyYears';
import SurveyPeriod from './Filters/SurveyPeriod';
import SurveyMode from './Filters/SurveyMode';
import TimeSlices from './Filters/TimeSlices';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

interface IProps {
    state: AnalysisFilterViewModel;
    updateState: (properties: Partial<AnalysisFilterViewModel>, callback?: (newState?: AnalysisFilterViewModel) => void) => Promise<void>;
    getResults: () => void;
    loading: boolean;
}

export default function TimeSeriesAnalysisFilter({ state, updateState, getResults, loading }: IProps) {
    return (
        <>
            <Backdrop
                open={loading}
                sx={{
                    backgroundColor: '#ffffff',
                    zIndex: (theme) => theme.zIndex.modal + 1,
                }}
            >
                <CircularProgress size="100px" color="primary" />
            </Backdrop>
            <Grid container size={12}>
                <Grid container size={4}>
                    <LandUseSelection state={state} updateState={updateState} />
                </Grid>
                <Grid container size={4}>
                    <SurveyMode state={state} updateState={updateState} />
                </Grid>
                <Grid container size={4}>
                    <SurveyYears state={state} updateState={updateState} />
                </Grid>
                <Grid container size={4}>
                    <TripRateParameters state={state} updateState={updateState} />
                </Grid>
                <Grid container size={4}>
                    <LocationType state={state} updateState={updateState} />
                </Grid>
                <Grid container size={4}>
                    <FlowDirection state={state} updateState={updateState} />
                </Grid>
                <Grid container size={2}>
                    <SurveyPeriod state={state} updateState={updateState} />
                </Grid>
                <Grid container size={6}>
                    <TimeSlices state={state} updateState={updateState} />
                </Grid>
                <Grid container size={4}>
                    <Grid container component={Paper} size={12} padding={2} minHeight={"190px"}>
                        <Grid size={12} height={"20px"} justifyItems={"center"}>
                            {state.timeSlice == null && <Typography color="warning">Please select a time period!</Typography>}
                        </Grid>
                        <Grid size={12}>
                            <Button disabled={state.timeSlice == null || loading} onClick={getResults}>Analyse Time Series</Button>
                        </Grid>
                        <Grid size={12} height={"20px"} justifyItems={"center"}>
                            <Typography color="warning">Due to the large amount of data used to generate the results, this may take a few moments</Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container size={12}>
                    <Grid container component={Paper} size={12} padding={2}>
                        <Typography >
                            The Time Series Analysis is an interactive tool that can chart trends in trip generation over time using data from within the TRICS system. The results are intended to support better decision making and the tool is designed to complement the standard trip rate calculation process, providing additional context towards a vision-led approach. The Time Series Analysis provides evidence of how trip rates by various modes and land uses have changed over time. Prior to undertaking the calculation, it is important to understand, depending on the land use and other selections made in the filtering process for the Time Series Analysis, that sample sizes can have considerable variation and smaller sample sizes are subject to potential skewing by individual surveys.
                        </Typography >
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}